import React from "react";
import { string, number } from "prop-types";

const HamburgerSvgIcon = ({ color = "white", size = 25 }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path d="M4.02402 13.0774C4.57959 13.0774 5.02997 12.627 5.02997 12.0715C5.02997 11.5159 4.57959 11.0655 4.02402 11.0655C3.46845 11.0655 3.01807 11.5159 3.01807 12.0715C3.01807 12.627 3.46845 13.0774 4.02402 13.0774Z" fill={color} />
        <path d="M4.02402 7.04169C4.57959 7.04169 5.02997 6.59131 5.02997 6.03574C5.02997 5.48017 4.57959 5.02979 4.02402 5.02979C3.46845 5.02979 3.01807 5.48017 3.01807 6.03574C3.01807 6.59131 3.46845 7.04169 4.02402 7.04169Z" fill={color} />
        <path d="M4.02402 19.1131C4.57959 19.1131 5.02997 18.6627 5.02997 18.1072C5.02997 17.5516 4.57959 17.1012 4.02402 17.1012C3.46845 17.1012 3.01807 17.5516 3.01807 18.1072C3.01807 18.6627 3.46845 19.1131 4.02402 19.1131Z" fill={color} />
        <path d="M21.1252 12.0715L9.05378 12.0715M21.1252 6.03574L9.05378 6.03574M21.1252 18.1072L9.05378 18.1072M5.02997 12.0715C5.02997 12.627 4.57959 13.0774 4.02402 13.0774C3.46845 13.0774 3.01807 12.627 3.01807 12.0715C3.01807 11.5159 3.46845 11.0655 4.02402 11.0655C4.57959 11.0655 5.02997 11.5159 5.02997 12.0715ZM5.02997 6.03574C5.02997 6.59131 4.57959 7.04169 4.02402 7.04169C3.46845 7.04169 3.01807 6.59131 3.01807 6.03574C3.01807 5.48017 3.46845 5.02979 4.02402 5.02979C4.57959 5.02979 5.02997 5.48017 5.02997 6.03574ZM5.02997 18.1072C5.02997 18.6627 4.57959 19.1131 4.02402 19.1131C3.46845 19.1131 3.01807 18.6627 3.01807 18.1072C3.01807 17.5516 3.46845 17.1012 4.02402 17.1012C4.57959 17.1012 5.02997 17.5516 5.02997 18.1072Z" stroke={color} strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

HamburgerSvgIcon.propTypes = {
    color: string,
    size: number
};

export default HamburgerSvgIcon;
